// src/routes/index.js
import { createBrowserRouter } from 'react-router-dom';
import authRoutes from './auth.routes';
import dashboardRoutes from './dashboard.routes';
import { Navigate } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    children: [
      {
        path: '',
        element: <Navigate to="/auth/login" replace />
      },
      authRoutes,
      dashboardRoutes
    ]
  }
]);

export default router;